// draggable and resizable directives
//

let module = angular.module('app.directives');

// Support both touch and non-touch interactions based on client type (iOS|Android).
// NOTE: attempting to detect whether using mouse or touch has a race condition,
// because by the time we'd check for first touch or mouse movement, the DOM
// could be filled already (specifically if user loads events page directly)
var events = {
  mousedown: 'mousedown',
  mousemove: 'mousemove',
  mouseup: 'mouseup',
  mouseover: 'mouseover',
  mouseout: 'mouseout',
};
if (
  (/iPad|iPhone|iPod/.test(navigator.userAgent) || navigator.userAgent.indexOf('Android') >= 0) &&
  'ontouchstart' in window
) {
  events = {
    mousedown: 'touchstart',
    mousemove: 'touchmove',
    mouseup: 'touchend',
    mouseover: 'touchstart',
    mouseout: 'touchcancel',
  };
}

function getX(evt) {
  evt = evt.originalEvent || evt;
  if (evt.touches) {
    return evt.touches[0].clientX;
  } else if (evt.changedTouches) {
    return evt.changedTouches[0].clientX;
  } else {
    return evt.clientX;
  }
}

function getY(evt) {
  evt = evt.originalEvent || evt;
  if (evt.touches) {
    return evt.touches[0].clientY;
  } else if (evt.changedTouches) {
    return evt.changedTouches[0].clientY;
  } else {
    return evt.clientY;
  }
}

module
  .directive('resizable', [
    '$document',
    function ($document) {
      return {
        restrict: 'A',
        scope: {
          aspectRatio: '=aspectRatio',
          onResize: '=onResize',
          onDrag: '=', //<-- to avoid multiple directives requiring isolated scope
        },
        controller: function ($scope) {
          'ngInject';
          this.onDrag = (...args) => $scope.onDrag(...args);
        },
        link: function (scope, element, attr) {
          var container = element.parents('.resizable-parent').first();
          if (!container.length) {
            console.warn('Cannot make resizable. Unable to find .resizable-parent from', element);
            return;
          }
          if (!scope.aspectRatio) {
            console.warn('Cannot make resizable without aspect-ratio specified.');
            return;
          }

          var dimension = {};
          var position = {};

          //create button for resizing
          var btn = document.createElement('span');
          btn.style.width = '15px';
          btn.style.height = '15px';
          btn.style.bottom = '0px';
          btn.style.right = '0px';
          btn.style.position = 'absolute';
          btn.style.visibility = 'hidden';
          btn.style.cursor = 'nwse-resize';
          btn.innerHTML = `
          <svg>
            <circle cx='12.5' cy='2.5' r='2' fill='#777777'></circle>
            <circle cx='7.5' cy='7.5' r='2' fill='#777777'></circle>
            <circle cx='12.5' cy='7.5' r='2' fill='#424242'></circle>
            <circle cx='2.5' cy='12.5' r='2' fill='#777777'></circle>
            <circle cx='7.5' cy='12.5' r='2' fill='#424242'></circle>
            <circle cx='12.5' cy='12.5' r='2' fill='#212121'></circle>
          </svg>`;
          element.append(btn);

          //bind resize function to button;
          btn['on' + events.mousedown] = function ($event) {
            $event.stopImmediatePropagation();
            position.x = getX($event);
            position.y = getY($event);
            var bounds = element[0].getBoundingClientRect();
            dimension.width = bounds.width;
            dimension.height = bounds.height;
            $document.bind(events.mousemove, mousemove);
            $document.bind(events.mouseup, mouseup);
            return false;
          };

          var mousemove = function ($event) {
            var dw = position.x - getX($event);
            var dh = position.y - getY($event);
            var bounds = container[0].getBoundingClientRect();
            var cW = bounds.width;
            var cH = bounds.height;

            // take smallest axis movement as constraint
            if (dw < dh) {
              var w = dimension.width - dw;
              var h = w * scope.aspectRatio;
            } else {
              var h = dimension.height - dh;
              var w = h / scope.aspectRatio;
            }
            var wPct = 100 * (w / cW);
            var hPct = 100 * (h / cH);
            if (wPct >= 100 || hPct >= 100) {
              if (wPct >= hPct) {
                wPct = 100;
                hPct = wPct * scope.aspectRatio * (cW / cH);
              } else {
                hPct = 100;
                wPct = (hPct / scope.aspectRatio) * (cH / cW);
              }
            }
            if (wPct < 1 || hPct < 1) {
              return false; // too small, don't let it shrinkify
            }

            element.css({
              width: wPct + '%',
              height: hPct + '%',
            });

            scope.onResize(wPct, hPct);

            return false;
          };

          var mouseup = function () {
            $document.unbind(events.mousemove, mousemove);
            $document.unbind(events.mouseup, mouseup);
          };

          //show button on hover
          element.bind(events.mouseover, function () {
            btn.style.visibility = 'visible';
          });
          element.bind(events.mouseout, function () {
            btn.style.visibility = 'hidden';
          });
        },
      };
    },
  ])
  .directive('draggable', [
    '$document',
    function ($document) {
      return {
        restrict: 'A',
        require: 'resizable',
        link: function (scope, element, attrs, resizableCtrl) {
          var container = element.parents('.draggable-parent').first();
          if (!container.length) {
            console.warn('Cannot make draggable. Unable to find .draggable-parent from', element);
            return;
          }
          var position = {};

          element.bind(events.mousedown, function ($event) {
            position.x = element.position().left;
            position.y = element.position().top;
            position.initialMouseX = getX($event);
            position.initialMouseY = getY($event);
            $document.bind(events.mousemove, mousemove);
            $document.bind(events.mouseup, mouseup);
            return false;
          });

          var mousemove = function ($event) {
            var dx = getX($event) - position.initialMouseX;
            var dy = getY($event) - position.initialMouseY;
            var bounds = container[0].getBoundingClientRect();
            var cW = bounds.width;
            var cH = bounds.height;
            var x = position.x + dx;
            var y = position.y + dy;
            var xPct = 100 * (x / cW);
            var yPct = 100 * (y / cH);
            yPct = Math.min(Math.max(0, yPct), 100);
            xPct = Math.min(Math.max(0, xPct), 100);
            element.css({
              left: xPct + '%',
              top: yPct + '%',
            });
            resizableCtrl.onDrag(xPct, yPct);
            return false;
          };

          var mouseup = function () {
            $document.unbind(events.mousemove, mousemove);
            $document.unbind(events.mouseup, mouseup);
          };
        },
      };
    },
  ]);



// WEBPACK FOOTER //
// ./app/directives/drag-resize.js